import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import styles from './TestimonialsSlider.scss';


export default class TestimonialsSlider extends Component {
  static propTypes = {
    testimonials: PropTypes.object,
  };

  renderTestimonial(testimonial) {
    return (
      <div className={styles.item} key={`testimonial-${testimonial.get('id')}`}>
        <p className={styles.testimonialContent}>
          {testimonial.get('content')}
        </p>
        <footer>

          <img src={testimonial.get('photo')} className={this.imageClassname(testimonial)} />
          <h4>{testimonial.get('name')}</h4>
          <span>{testimonial.get('title')}</span>
        </footer>
      </div>
    );
  }

  imageClassname(testimonial) {
    if (testimonial.get('title').length > 41) {
      return 'circle float-left margin-bottom';
    }
    else {
      return 'circle float-left';
    }
  }

  render() {
    const { testimonials } = this.props;

    if (!testimonials || testimonials.isEmpty()) {
      return null;
    }

    return (
      <Slider
        dots={true}
        infinite={true}
        autoplay={true}
        autoplaySpeed={10000}
        arrows={false}
        adaptiveHeight={true}
        className={styles.box}
      >
        {testimonials.map(testimonial => this.renderTestimonial(testimonial))}
      </Slider>
    );
  }

}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/TestimonialsSlider.jsx